const Loader = ({ styleObj = {} }) => {
    return (
        <div style={{ height: '100vh' }}>
            <div className="preloader-main" style={{ display: 'flex', ...styleObj }}>
                <div className="loader">
                    <svg className="spinner" viewBox="0 0 50 50">
                        <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default Loader;
